<template>
  <div>
    <b-row>
      <b-col>
        <FederationTab
            :items="items"
            :columns="columnsFed"
            :isCalled="isCalledFed"
            :selectedValue="selectedItem"
            @editItem="showEditDialog"
            @updateData="loadItems"
            v-model="selectedItem"
            :captionSpr="captionFed"
            :urls="urls"
            :captionTab="captiontable"
            ref="FederationTab"
        >
        </FederationTab>
      </b-col>
    </b-row>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование федерации" size="lg" hide-footer id="editModal">
      <div class="d-block">
        <b-input-group prepend="Наименование" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите наименование" v-model="selectedItem.name"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.name">Указано пустое наименование</b-form-invalid-feedback>

        <b-input-group prepend="Краткое наименование" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите наименование" v-model="selectedItem.shortName"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.shortName">Указано пустое краткое наименование</b-form-invalid-feedback>

        <b-input-group prepend="ФИО Руководителя" class="mt-1" size="sm">
          <b-form-input id="fed_fio" type="text" placeholder="Укажите руководителя" readonly
                        v-model="selectedItem.leaderFIO"/>
          <b-input-group-append>
            <b-button size="sm" text="Указать" variant="success" @click="showPeopleDialog()">Выбрать</b-button>
          </b-input-group-append>
        </b-input-group>

        <b-input-group prepend="Адрес федерации" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите адрес" v-model="selectedItem.adress"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.adress">Указан пустой адрес</b-form-invalid-feedback>

        <b-input-group prepend="Телефон федерации" class="mt-1" size="sm">
          <b-input-group-append>
            <the-mask type="text" :mask="['+7 (###) ###-####', '+7 (###) ###-####']"
                      v-model="selectedItem.phoneNumber"
                      placeholder="+7(999) 999-9999"/>
          </b-input-group-append>
        </b-input-group>

        <b-input-group prepend="Адрес федерации" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите электронный адрес" v-model="selectedItem.email"/>
        </b-input-group>

        <div class="text-right">
          <b-button class="mt-1 mr-1" variant="outline-primary" @click="saveFed">Сохранить</b-button>
          <b-button class="mt-1" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="peopleModal" v-model="modalPeopleOpened" title="Выбрать руководителя" size="lg" id="peopleModal" @ok="selectPeople">
      <div class="d-block">
        <PeopleSelect
            :isCalledPeople="true"
            :columnsPeople="columnsPeople"
            v-model="selectedPeople"
            @selectItem="selectPeople">
        </PeopleSelect>
      </div>
    </b-modal>

  </div>
</template>

<script>
import FederationTab from '@/components/TabSpr.vue'
import http from '@/http-common'
import PeopleSelect from '@/views/people/PeoplePage.vue'

export default {
  name: 'FederationsList',
  components: {FederationTab, PeopleSelect},
  props: {
    isCalledFed: {
      type: Boolean,
      default: false,
    },
    selectedValue: {
      type: Object,
      default: null
    },
    columnsFed: {
      type: Array,
      default: () => [
        {key: 'name', label: 'Наименование'},
        {key: 'shortName', label: 'Краткое наименование'},
        {key: 'leaderFIO', label: 'ФИО Руководителя'},
        {key: 'adress', label: 'Адрес'},
        {key: 'phoneTel', label: 'Телефон', firstClass: 'width10'},
        {key: 'email', label: 'email'},
        {key: 'edit_field', label: '', firstClass: 'width10'}
      ],
    }
  },
  data() {
    return {
      captiontable: 'Спортивные федерации',
      items: [],
      selected: [],
      captionFed: {
        name: 'Федерация',
        nameR: 'федерацию'
      },
      urls: {
        save: '/federation/save',
        delete: '/federation/delete',
      },
      selectedItem: {
        id: null,
        name: '',
        shortName: '',
        adress: '',
        phoneNumber: '',
        leaderFio: '',
        email: ''
      },
      modalEditOpened: false,
      modalPeopleOpened: false,
      columnsPeople: [
        {key: 'fio', label: 'ФИО'},
        {key: 'dolzhn', label: 'Дожность'},
        {key: 'edit_field', label: ''}
      ],
      selectedPeople: {},
      validValue: {
        name: true,
        shortName: true,
        adress: true,
        form: true,
      }
    }
  },
  created() {
    this.loadItems();
  },
  methods: {
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.name || this.selectedItem.name === '') {
        this.validValue.name = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.shortName || this.selectedItem.shortName === '') {
        this.validValue.shortName = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.adress || this.selectedItem.adress === '') {
        this.validValue.adress = false;
        this.validValue.form = false;
      }
    },
    rowSelected(items) {
      this.selected = items;
      //var rec = this.selectedItem;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      //this.selectedItem = rec;
      this.$emit('input', this.selectedItem)
    },
    loadItems() {
      var vm = this;
      http.get('/federation/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    showEditDialog() {
      if (!this.isCalledFed) {
        this.modalEditOpened = !this.modalEditOpened;
      } else {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      }
    },
    saveFed() {
      if (!this.isCalledFed) {
        this.checkForm();
        if (this.validValue.form) {
          this.modalEditOpened = false;
          this.$refs.FederationTab.save(this.selectedItem);
        }
      } else {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      }
    },
    showPeopleDialog() {
      this.modalPeopleOpened = !this.modalPeopleOpened;
    },
    selectPeople() {
      this.selectedItem.leaderFIO = this.selectedPeople.fio;
      this.selectedItem.leaderId = this.selectedPeople.id;
      this.modalPeopleOpened = false;
    }
  },
  computed: {
    getBack() {
      return "background: rgba(255, 255, 150, 0.8);"
    },
    classRowCalled: function () {
      return {
        'col-xs-12 col-sm-12 col-md-12 col-lg-12': this.isCalledFed,
        'col-xs-12 col-sm-12 col-md-12 col-lg-8': !this.isCalledFed
      }
    }
  }
}
</script>

